import React from 'react'

const Eventadvertisement = () => {
    return (
        <div>

        </div>
    )
}

export default Eventadvertisement
